import { render, staticRenderFns } from "./ConsumersProvidersDetail.vue?vue&type=template&id=18c76c60&"
import script from "./ConsumersProvidersDetail.vue?vue&type=script&lang=js&"
export * from "./ConsumersProvidersDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsumersProvidersDetail.vue?vue&type=style&index=0&id=18c76c60&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c76c60')) {
      api.createRecord('18c76c60', component.options)
    } else {
      api.reload('18c76c60', component.options)
    }
    module.hot.accept("./ConsumersProvidersDetail.vue?vue&type=template&id=18c76c60&", function () {
      api.rerender('18c76c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConsumersProvidersDetail.vue"
export default component.exports